import { createQueryKeys } from "@lukemorales/query-key-factory";

import type { CoreApiClient } from "../client";
import type { Mesh } from "../types/mesh.type";

export const createMeshQueries = (api: CoreApiClient) => {
  const { client } = api;

  const list = async (buildingId: string): Promise<Mesh[]> => {
    const { data, error } = await client.GET(`/buildings/{buildingId}/meshes`, {
      params: { path: { buildingId } },
    });
    if (error) throw new Error(error.message);
    return data;
  };

  return {
    list,
    queries: createQueryKeys("mesh", {
      building: (buildingId: string) => ({
        queryKey: [buildingId],
        queryFn: () => list(buildingId),
      }),
    }),
  };
};
